// frontend/src/pages/AuthCallback.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';import { useThemeSettings } from "../contexts/ThemeContext";

function AuthCallback() {const { t } = useThemeSettings();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();

  useEffect(() => {
    async function handleAuthCallback() {
      try {
        // Parse the URL search params
        const searchParams = new URLSearchParams(location.search);

        // Get the tokens from the URL (sent by your backend)
        const token = searchParams.get('token');
        const refreshToken = searchParams.get('refreshToken');

        if (!token) {
          console.error('No token received');
          setError('No authentication token received');
          setLoading(false);
          return;
        }

        // Get the redirect path from the URL (just the path, not full URL)
        let redirectTo = searchParams.get('redirectTo') || '/dashboard';

        // Ensure the redirectTo is just a path, not a full URL
        if (redirectTo.startsWith('http')) {
          try {
            const url = new URL(redirectTo);
            redirectTo = url.pathname + url.search;
          } catch (e) {
            redirectTo = '/dashboard';
          }
        }

        //console.log('Auth callback - received tokens:', {
        //  hasAccessToken: !!token,
        //  hasRefreshToken: !!refreshToken,
        //  redirectTo
        //});

        // Pass both tokens to the login function in AuthContext
        const result = await auth.login(token, refreshToken, redirectTo);

        if (result.success) {
          //console.log('Authentication successful, redirecting to:', redirectTo);
          // Navigate to the intended page
          navigate(redirectTo, { replace: true });
        } else {
          setError(result.message || 'Authentication failed');
          setLoading(false);
        }
      } catch (err) {
        console.error('Authentication error:', err);
        setError(err.message || 'Authentication failed');
        setLoading(false);
      }
    }

    handleAuthCallback();
  }, [location, navigate, auth]);

  if (error) {
    return (
      <Box className="page-transition-enter" sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3
      }}>
        <Alert severity="error" className="slide-up" sx={{ mb: 2, maxWidth: 600 }}>
          {error}
        </Alert>
        <Box sx={{ mt: 2 }}>
          <button onClick={() => navigate('/login')}>{t ? t("AuthCallback.return_login") : "Return to Login"}

          </button>
        </Box>
      </Box>);

  }

  // Show loading indicator while processing
  return (
    <Box className="page-transition-enter" sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh'
    }}>
      <div className="spinner" />
      <Typography variant="h6" className="fade-in" sx={{ mt: 2 }}>{t ? t("AuthCallback.completing_authentication") : "Completing authentication..."}

      </Typography>
    </Box>);

}

export default AuthCallback;